import { __assign, __awaiter, __generator, __read, __spreadArray } from "tslib";
var Logger = require('./drivers/abstract/logger');
var Spell = require('./spell');
var Bone = require('./bone');
var Collection = require('./collection');
var _a = require('./data_types'), DataTypes = _a.invokable, LENGTH_VARIANTS = _a.LENGTH_VARIANTS;
var sequelize = require('./adapters/sequelize');
var heresql = require('./utils/string').heresql;
var Realm = require('./realm/base');
var AbstractDriver = require('./drivers/abstract');
var isBone = require('./utils').isBone;
/**
 * @typedef {Object} RawSql
 * @property {boolean} __raw
 * @property {string} value
 * @property {string} type
 */
/**
 * Connect models to database. Need to provide both connect options and models.
 * @alias module:index.connect
 * @param {Object} opts
 * @param {string} opts.client - client name
 * @param {string|Bone[]} opts.models - an array of models
 * @returns {Pool} the connection pool in case we need to perform raw query
 */
export var connect = function connect(opts) {
    return __awaiter(this, void 0, void 0, function () {
        var realm;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign({ Bone: Bone }, opts);
                    if (opts.Bone.driver)
                        throw new Error('connected already');
                    realm = new Realm(opts);
                    return [4 /*yield*/, realm.connect()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, realm];
            }
        });
    });
};
export var disconnect = function disconnect(realm) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(realm instanceof Realm && realm.connected)) return [3 /*break*/, 2];
                    return [4 /*yield*/, realm.disconnect.apply(realm, __spreadArray([], __read(args), false))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/];
            }
        });
    });
};
Object.assign(Realm.prototype, { DataTypes: DataTypes });
export default Realm;
export { Bone };
export { Collection };
export { DataTypes };
export { Logger };
export { Spell };
export { sequelize };
export { heresql };
export * from './hint';
export * from './decorators';
export { AbstractDriver };
export { default as Raw } from './raw';
export { LENGTH_VARIANTS };
export { isBone };
// TODO: missing migrations and MYSQL, PG, SQLITE drivers
//# sourceMappingURL=browser.js.map